export default __webpack_public_path__ + "static/assets/968d91edff114957b894587cf739b92e.jpg";